<template>
  <div :class="{'isActive': active}" class="faqItem">
    <button type="button" @click="active = !active" class="faqItem__Question">
      <h2 v-text="item.question" />

      <transition name="fade" mode="out-in">
        <Icon v-if="!active" name="add" />
        <Icon v-else name="subtract" />
      </transition>
    </button>

    <div class="faqItem__Answer">
      <div>
        <div v-html="item.answer" />
      </div>
    </div>
  </div>
</template>

<script setup>
  defineProps({
    item: {}
  });

  const active = ref(false);
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_faqItem.scss');
</style>